import React from "react";
import { motion } from "framer-motion";
import "./navRoutes";
import routes from "./navRoutes";

import "../Info";
import info from "../Info";

export default function Navbar({ handleOnClick, scrollPosition }) {
  // Calculate the scale, margin, and position values based on scrollPosition
  const scaleFactor = Math.max(2.2, 5.5 - ((5.5 - 2) / 977) * scrollPosition);
  const marginValue = Math.max(1, 2.5 - ((2.5 - 1) / 977) * scrollPosition);
  const positionValue = Math.max(35, 100 - ((100 - 35) / 977) * scrollPosition);

  return (
    <motion.div
      className="lg:p-20 p-5 flex flex-col justify-between z-50 fixed top-0 right-0 sm:w-auto lg:left-0 lg:w-fit"
      animate={{
        height: `${positionValue}vh`,
      }}
      transition={{ duration: 0, ease: "linear" }}
    >
      <div className="w-full text-right sm:text-left w-fit">
        <a
          href="/"
          className="lg:text-2xl text-lg mb-4 text-[var(--pmFont)] font-bold"
          style={{
            fontFamily: "Arial",
            textShadow: "2px 2px 55px rgba(0, 0, 0, 0.5)",
          }}
        >
          {info.fname} {info.lname}
        </a>
        <br />
        <a
          href="/"
          className="lg:text-base text-sm text-[var(--pmFont)] font-light"
          style={{
            fontFamily: "Arial",
            textShadow: "2px 2px 55px rgba(0, 0, 0, 0.5)",
          }}
        >
          {info.title}
        </a>
      </div>

      <motion.ul
        className="list-none"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.1 }}
      >
        {routes.map((route, index) => (
          <motion.li
            key={index}
            className="transform transition-transform ease"
            style={{
              fontSize: `${scaleFactor}rem`,
              marginBottom: `-${marginValue}rem`,
              transition: "transform 0.3s all ease",
            }}
            whileHover={{ scale: 1.08, originX: 0 }}
            whileTap={{ scale: 0.95 }}
            transition={{ duration: 0.1 }}
          >
            <button
              onClick={() => handleOnClick(route.route)}
              className="text-[var(--pmFont)] font-bold w-full t  ext-right md:text-left"
              style={{
                fontFamily: "Arial",
                textShadow: "2px 2px 55px rgba(0, 0, 0, 0.5)",
              }}
            >
              {route.name}
            </button>
          </motion.li>
        ))}
      </motion.ul>
    </motion.div>
  );
}
